import { SvgIcon, ListItemIcon, ListItemText } from '@mui/material'
import React, { FC, ReactNode, useCallback } from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import {
  continueRoute,
  isModalDialogOpen,
  isNavMenuRoute,
  isUnsaveFormData,
} from '../../graphql/local'
import { useReactiveVar } from '@apollo/client'
import { useCustomHistory } from '../../hooks'
import { StyledBadge, StyledMenuItem } from './StyledComponents'

export const MainMenuItem: FC<{
  icon: ReactNode
  primary: ReactNode
  path?: string | string[]
  disabled?: boolean
  countNum?: number | undefined
  detailsPath?: string | string[]
  resetCustomHistory?: boolean
  onClick?: () => void
}> = ({
  icon,
  primary,
  countNum,
  path,
  disabled,
  detailsPath,
  resetCustomHistory,
  onClick,
  ...props
}) => {
  const match = useRouteMatch({ path: path || 'unknownPath', exact: false })
  const matchDetails = useRouteMatch(detailsPath || 'unknownPath')
  const history = useHistory()
  const isUnsavedFormData = useReactiveVar(isUnsaveFormData)
  const { resetHistory } = useCustomHistory()

  const redirect = useCallback(() => {
    if (onClick) {
      onClick()
      return
    }
    resetCustomHistory && resetHistory()
    if (path) {
      if (isUnsavedFormData) {
        isModalDialogOpen(true)
        isNavMenuRoute(true)
        continueRoute(`${path}`)
      } else if (path !== history.location.pathname) {
        history.push(typeof path === 'string' ? path : path[0])
      }
    }
  }, [history, path, isUnsavedFormData, resetHistory, onClick])

  return (
    <StyledMenuItem
      selected={!!match || !!matchDetails}
      onClick={redirect}
      disabled={disabled}
      {...props}
    >
      <ListItemIcon sx={{ minWidth: '36px', color: 'common.black' }}>
        <SvgIcon>{icon}</SvgIcon>
      </ListItemIcon>
      <ListItemText primary={primary} sx={{ m: 0, pr: 1.875 }} />
      <StyledBadge
        badgeContent={countNum}
        color="secondary"
        overlap={'rectangular'}
        data-test="redBage"
        sx={{ height: 0 }}
      />
    </StyledMenuItem>
  )
}
